import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-red-900/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_eef57605-b57f-42da-9484-428b5038f0b4/artifacts/n8pfvrwl_640882159_1565121207907925_6876786731636828058_n.jpg" 
              alt="Swift HandyMen" 
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className="text-white hover:text-red-500 transition-colors font-medium"
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className="text-white hover:text-red-500 transition-colors font-medium"
            >
              About
            </Link>
            <Link 
              to="/services" 
              className="text-white hover:text-red-500 transition-colors font-medium"
            >
              Services
            </Link>
            <Link 
              to="/contact" 
              className="text-white hover:text-red-500 transition-colors font-medium"
            >
              Contact
            </Link>
            <Button 
              className="bg-red-600 hover:bg-red-700 text-white font-semibold px-6"
              onClick={() => window.location.href = 'tel:8134491138'}
            >
              <Phone className="w-4 h-4 mr-2" />
              (813) 449-1138
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-red-900/20">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/" 
                className="text-white hover:text-red-500 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/about" 
                className="text-white hover:text-red-500 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                About
              </Link>
              <Link 
                to="/services" 
                className="text-white hover:text-red-500 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Services
              </Link>
              <Link 
                to="/contact" 
                className="text-white hover:text-red-500 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
              <Button 
                className="bg-red-600 hover:bg-red-700 text-white font-semibold w-full"
                onClick={() => window.location.href = 'tel:8134491138'}
              >
                <Phone className="w-4 h-4 mr-2" />
                (813) 449-1138
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
